<template>
     <el-form
        :model="contactForm"
        :rules="validationRules"
        ref="form"
        class="w-1/2"
    >
        <h4 class="font-display font-semibold mt-8 pb-3">Accreditation Contact</h4>

        <div class="grid grid-cols-10 gap-2 mb-0 w-full">
            <el-form-item prop="accredContactFirstName" class="col-span-5">
                <label class="block font-bold font-display text-xs text-grey-2 uppercase leading-tight">First name</label>
                <el-input v-model="contactForm.accredContactFirstName" required></el-input>
            </el-form-item>
            <el-form-item prop="accredContactLastName" class="col-span-5">
                <label class="block font-bold font-display text-xs text-grey-2 uppercase leading-tight">Last name</label>
                <el-input v-model="contactForm.accredContactLastName" required></el-input>
            </el-form-item>
        </div>
        <div class="grid grid-cols-10 gap-2 mb-0 w-full">
            <el-form-item prop="accredContactEmail" class="col-span-5">
                <label class="block font-bold font-display text-xs text-grey-2 uppercase leading-tight">Email</label>
                <el-input v-model="contactForm.accredContactEmail" required></el-input>
            </el-form-item>
            <el-form-item prop="accredContactPhone" class="col-span-5">
                <label class="block font-bold font-display text-xs text-grey-2 uppercase leading-tight">Phone</label>
                <PhoneNumber
                    name="accredContactPhone"
                    v-model="contactForm.accredContactPhone"
                    ref="accredContactPhone"
                    :required="true"
                    :validPhone="true"
                />
            </el-form-item>
        </div>
    </el-form>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import PhoneNumber from '@/components/shared/PhoneNumber'
import { DEFAULT_ACCRED } from '@/config/constants'

export default {
    name: 'AccreditationContact',
    components: { PhoneNumber },
    props: {
        value: {
            type: Object,
            default: () => ({ ...DEFAULT_ACCRED })
        }
    },
    emits: ['input'],
    setup(props, { emit }) {
        const isValid = ref(true)
        const form = ref({})
        const accredContactPhone = ref({})
        const validationRules = ref({
            accredContactFirstName: [{ required: true, message: 'This field is required', trigger: 'blur' }],
            accredContactLastName: [{ required: true, message: 'This field is required', trigger: 'blur' }],
            accredContactEmail: [{ required: true, message: 'This field is required', trigger: 'blur' }],
        })

        const contactForm = computed({
            get() {
                return props.value || { ...DEFAULT_ACCRED }
            },
            set(value) {
                emit('input', value)
            }
        })
        
        //#region functions
        const validate = () => {
            console.log('form and valid value', form.value)
            return Promise.all([accredContactPhone.value?.validate(), form.value?.validate()])
        }
        //#endregion

        return {
            isValid,
            form,
            accredContactPhone,
            contactForm,
            validationRules,
            validate
        }
    }
}
</script>